import Insight from "../insightClass";
import React from "react";
import { insight91Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight091 = new Insight(
  "23 January 2026",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight91Media[0],
    alt: "offshore wind farm",
  },
  "Global Offshore Wind Weekly (2026-01-23)",
  "",
  `JERA Nex BP will buy EnBW’s stake in the Mona offshore wind project and has signed a lease agreement with The Crown Estate for Mona. The move follows EnBW’s announcement that it will take a €1.2 billion impairment charge after pulling out of two projects it was developing with JERA Nex bp — Mona and Morgan — after losing out in a major UK offshore tender.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2026-01-23)</h1>
    <h2></h2>
    <p className="article-date">23 January 2026</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>
    <h3>
      1. UK: JERA Nex BP to buy EnBW’s stake in Mona; Morgan lease paused in
      current market conditions
    </h3>
    <p>
      JERA Nex BP will buy EnBW’s stake in the Mona offshore wind project and
      has signed a lease agreement with The Crown Estate for Mona. The move
      follows EnBW’s announcement that it will take a €1.2 billion impairment
      charge after pulling out of two projects it was developing with JERA Nex
      bp — Mona and Morgan — after losing out in a major UK offshore tender.
    </p>
    <p>
      EnBW cited a significant rise in supply-chain costs, weaker electricity
      market prices and higher interest rates. Mona could deliver up to 1.5 GW
      once operational. JERA Nex bp said it will not proceed with the Morgan
      project lease in current market conditions, and the parties will work with
      stakeholders to manage implications and close out remaining activities.
      Financial details were not disclosed.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      This is rapid “portfolio triage” in action: preserve the asset with the
      clearest route to future bankability (Mona) while stopping capital leakage
      on the one that cannot clear hurdles under today’s assumptions (Morgan).
      The strategic message is that UK pre-FID portfolios are becoming more
      option-like, with sponsors actively reshaping ownership and sequencing to
      keep at least one project investable.
    </p>
    <p>
      For policy and seabed managers, it underscores a pressure point: when
      costs and rates move quickly, auction outcomes can trigger immediate
      corporate decisions — so mechanisms that support re-entry (timing,
      visibility of future rounds, and manageable holding costs) become
      increasingly important to avoid losing mature projects from the pipeline.
    </p>
    <h3>
      2. UK: RWE signs eight-year PPA to power a London Docklands data centre
      with wind energy
    </h3>
    <p>
      RWE has signed an eight-year power purchase agreement with Global Switch
      to supply renewable electricity for a data centre in London’s Docklands.
      From now until 2033, RWE will deliver a cumulative total of 70 GWh of
      renewable electricity each year, supporting the facility’s expansion and
      densification. The site was previously chosen to host one of Europe’s
      largest installations of Nvidia H100 and H200 GPUs and to showcase
      advanced liquid cooling technologies. Global Switch said the agreement is
      a key step towards its goal of purchasing 100% renewable energy by 2030.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      Data centres are fast becoming a defining demand segment for offshore
      wind: load growth is structural, and corporate buyers increasingly want
      credible, long-term decarbonisation. The next evolution is “match
      quality”. Buyers will move beyond annual certificates and seek products
      that better align with 24/7 consumption, which can drive demand for
      shaping, storage, and multi-asset portfolios (wind plus batteries, demand
      response, and grid services).
    </p>
    <p>
      For offshore wind developers, this expands the commercial toolkit: value
      is no longer only in selling MWh, but in packaging bankable, auditable
      clean power solutions. For the UK, the unlock is grid delivery — if
      connection timelines lag, corporate demand will not translate into
      incremental clean capacity at the pace required.
    </p>
    <h3>
      3. Scotland: Neart na Gaoithe launches what it calls the UK’s largest
      seabird monitoring study at an operational offshore wind farm
    </h3>
    <p>
      The Neart na Gaoithe (NnG) offshore wind farm in Scotland has launched
      what the project owner describes as the UK’s largest seabird monitoring
      study, aiming to gather detailed data on bird behaviour around wind
      turbines. The 450 MW project, located about 15.5 km off the Fife coast in
      the Outer Firth of Forth, became fully operational in 2025. The study will
      run continuously over two breeding seasons from March, using radar
      systems, high-resolution cameras and collision detection technology
      installed across the site. Environmental consultancy STRIX has been
      appointed to carry out monitoring and data analysis.
    </p>
    <p>
      The work builds on seven years of research at NnG and is framed as a
      requirement under the project’s Environmental Monitoring Programme set by
      Scottish Ministers. The monitoring systems include Birdtrack-Radar3D and
      six collision detection systems mounted on turbine towers. NnG notes
      collaboration with other regional projects, including Seagreen 1 and
      Berwick Bank.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      This is material for the UK pipeline because ecological evidence is
      increasingly the binding constraint for consenting and design.
      High-quality operational data can help move assessments from
      precaution-driven assumptions toward evidence-led mitigation — potentially
      reducing uncertainty for future projects and strengthening defensible
      design choices (layout, lighting, curtailment protocols, monitoring
      requirements).
    </p>
    <p>
      The strategic opportunity is regional standardisation: shared
      methodologies across multiple projects in Forth and Tay can create
      comparable datasets and faster learning. Over time, this can lower
      consenting risk premiums and improve schedule confidence. The industry
      should also watch how monitoring outputs translate into practical
      measures: the value comes not from data collection alone, but from turning
      insights into clear, repeatable planning and operational controls.
    </p>
    <h3>
      4. Netherlands: Government prepares a 1 GW offshore wind tender at
      IJmuiden Ver Gamma-A (reduced from earlier plans)
    </h3>
    <p>
      The Netherlands is preparing an offshore wind tender of up to 1 GW,
      described as half of what was initially promised for 2026. The auction
      will focus on a single project at IJmuiden Ver Gamma-A in the North Sea.
      It is expected to be a subsidy-supported tender under the main government
      subsidy programme, offering a maximum support rate of £90/MWh.
    </p>
    <p>
      Officials said restricting the tender to 1 GW is intended to improve the
      chances of receiving bids and reduce the risk of further postponements
      after previous tenders received no bids amid rising costs and lower
      electricity demand. The tender is expected to begin around September 2026,
      following a public consultation and subject to state-aid approval from the
      European Commission.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      The key signal is not “less ambition”, but “more realism”. The Netherlands
      is optimising for bid participation and deliverability after market
      feedback. For developers, auction attractiveness will hinge on risk
      allocation: grid connection responsibility, schedule certainty, and the
      degree of non-price requirements.
    </p>
    <p>
      For the supply chain, volume smoothing matters as much as volume size: a
      smaller single-year tender can be manageable if the multi-year pipeline
      remains credible and sequenced. Strategically, this points to an emerging
      European pattern — governments are recalibrating cadence to avoid empty
      tenders, while developers bid more conservatively to protect returns under
      higher capex and financing costs.
    </p>
    <h3>
      5. Germany: He Dreiht reaches halfway on turbine installation; full
      commissioning targeted by summer 2026
    </h3>
    <p>
      At EnBW’s He Dreiht offshore wind farm in Germany, turbine installation
      has reached the halfway mark, with 32 of 64 Vestas 15 MW turbines
      installed. The 960 MW project is being built about 85 km northwest of
      Borkum.
    </p>
    <p>
      The installation vessel Wind Orca is transporting components for three
      turbines at a time from Esbjerg, Denmark, and placing them on foundations
      offshore. EnBW plans to install and commission all 64 turbines by summer
      2026. The project produced first power in November. He Dreiht is owned by
      a consortium including EnBW, Allianz, AIP and Norges Bank Investment
      Management, and the project cost is cited as €2.4 billion.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      He Dreiht is a strong example of why execution cadence is now a
      competitive advantage. As turbine ratings increase, each installation step
      becomes heavier, more weather-sensitive, and more dependent on port
      readiness and vessel productivity.
    </p>
    <p>
      Visible construction milestones help rebuild confidence after years of
      cost inflation headlines, but they also shift attention to integration
      risks: grid reliability, curtailment management, and market design that
      sustains stable revenues in high-renewables systems. For investors, the
      practical watchpoints are installation productivity (days per turbine),
      commissioning pace, and the robustness of offshore logistics — because
      these directly affect final capex, schedule, and the risk profile of
      late-stage projects.
    </p>
    <h3>
      6. Türkiye: Industry signals first offshore wind tender targeted by
      end-2026; ambitions set out for 2035 and 2040
    </h3>
    <p>
      Türkiye is looking to open its first offshore wind tender by the end of
      2026, with a possible pathway to installing the first turbines by
      2030–2031, according to comments attributed to the president of the
      Turkish Wind Energy Association (TÜREB).
    </p>
    <p>
      The Ministry of Energy and Natural Resources has reportedly spent the past
      two to three years identifying suitable sites, designing tender mechanisms
      and exploring financing models. Türkiye’s National Energy Plan aims for 5
      GW of offshore wind by 2035, and an offshore wind roadmap launched with
      the World Bank outlined potential for up to 7 GW by 2040. Initial
      exploration areas referenced include parts of the Aegean Sea, the Sea of
      Marmara, and to a lesser extent the Black Sea.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      A first tender is strategically meaningful because it signals intent to
      move from roadmap to bankable pipeline. The critical success factor will
      be auction design: bankability, grid connection clarity, and manageable
      developer risk for early projects, especially if Türkiye wants
      international capital and experienced offshore contractors to participate.
    </p>
    <p>
      Regional geopolitics aside, the commercial logic is clear: as Europe’s
      supply chain seeks stable demand, new markets that can offer predictable
      rules and permitting pathways can attract capability and investment. For
      Türkiye, sequencing matters — a pilot tender that prioritises
      deliverability and learning-by-doing can be more valuable than aggressive
      headline GW targets.
    </p>
    <h3>
      7.Global: Vessel fleet study suggests up to ~400 GW installed by 2030 may
      be possible on vessel capacity—yet newbuilds needed outside China
    </h3>
    <p>
      A scenario study concludes that the global fleet of offshore wind
      installation vessels could, under aligned conditions and alongside
      additional vessel orders and supportive market factors, enable
      installations that bring total global offshore wind capacity to around 400
      GW by 2030.
    </p>
    <p>
      The analysis emphasises this is vessel-capacity potential, not a forecast,
      and that outcomes depend on broader supply-chain readiness, market
      conditions and political ambition. The study suggests that reaching 500 GW
      by 2030 is unlikely due to vessel availability, investment lead times and
      wider constraints. It also highlights structural separation between
      China’s domestically focused fleet and internationally classed vessels,
      limiting cross-regional sharing.
    </p>
    <p>
      Outside China, the study indicates sustained annual newbuild investment of
      roughly €2.5–€4 billion over the next three years could be required to
      reach around 175 GW installed outside China by 2030; without that, the
      non-Chinese fleet could support a lower total. Turbine upscaling is also
      cited as creating potential mismatches with crane height and lifting
      capacity.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      This is a timely reminder that offshore wind is constrained by industrial
      physics as much as policy. Vessel availability is necessary but not
      sufficient: ports, manufacturing throughput, HV equipment, cables and
      consenting all interact with vessel logistics. The “China vs
      rest-of-world” fleet split is especially important—international projects
      cannot assume Chinese vessel capacity will flex into their markets.
    </p>
    <p>
      For developers and governments, the actionable implication is
      coordination: forecasting and multi-project vessel planning can unlock
      productivity without proportional fleet expansion. For investors, this
      strengthens the case for long-term exposure to enabling
      infrastructure—vessels, ports, specialised cranes, and installation
      services—because these assets sit on the critical path of gigawatt-scale
      deployment.
    </p>
    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
